export type order = {
    [key: string]: string;
};

export function orderHelper(orders: order) {
    let index = 0;
    const queryParams = Object.entries(orders).reduce((acc, [key, value]) => {
        if (value && !value.includes('0000-00-00')) {
            acc.push(`Sort[${index}].FieldName=${key}&Sort[${index}].Order=${value}`);
            index++;
        }
        return acc;
    }, []);

    return queryParams.join('&');
}
